/**
 * Which TC dashboard tabs a user sees (TC-DASHBOARD-V2-DESIGN §6): Operations everyone, Finance with finance read,
 * Performance & Team TC_ADMIN only (salaries, commission, profit by person).
 */

import { can } from '../roleUtils';

export const TABS = { ops: 'Operations', fin: 'Finance', perf: 'Performance & Team' };

export const visibleTabs = (user) => [
  'ops',
  ...(can(user, 'finance', 'read') ? ['fin'] : []),
  ...(user?.role === 'TC_ADMIN' ? ['perf'] : []),
];

// The stored tab while still visible; a finance-only user (no work order read) lands on Finance; else Operations
export const defaultTab = (user, stored) => {
  const tabs = visibleTabs(user);
  if (stored && tabs.includes(stored)) return stored;
  if (tabs.includes('fin') && !can(user, 'work_order', 'read')) return 'fin';
  return 'ops';
};
